import { defineComponent as _defineComponent } from 'vue';
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted, onUnmounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'IframeContainer',
  props: {
    id: String,
    // iframe 名称
    name: String,
    // iframe 页面地址
    src: String,
    // 边框
    frameborder: {
      type: String,
      default: '0'
    },
    // 宽度
    width: {
      type: String,
      default: '100%'
    },
    // 高度
    height: {
      type: String,
      default: '100%'
    },
    scrolling: {
      type: String,
      default: 'no'
    },
    // 自动关闭时间（毫秒）
    autoCloseTime: {
      type: Number,
      default: 300000 // 默认5分钟
    }
  },
  emits: ['load', 'autoClose'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const iframeRef = ref(null);
    let timer = null;
    // props
    onMounted(() => {
      iframeRef.value.onload = () => {
        console.log('onload');
        emits('load');
        // 如果设置了自动关闭时间，则启动定时器
        if (props.autoCloseTime && props.autoCloseTime > 0) {
          timer = window.setTimeout(() => {
            // 触发自动关闭事件
            emits('autoClose');
            // 移除iframe元素
            if (iframeRef.value) {
              iframeRef.value.remove();
            }
          }, props.autoCloseTime);
        }
      };
    });
    onUnmounted(() => {
      // 组件卸载时清除定时器
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("iframe", _mergeProps({
        ref_key: "iframeRef",
        ref: iframeRef
      }, props), null, 16);
    };
  }
});